// enabled: true
// key: "KUBERNETES-24"
// scanFrequency: 60000
// status: "INITIALIZING"
// type: "KUBERNETES"
// uniqueId: "829699521465:us-east-1:Retail-Apps-Cluster"
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const kubernetesAccountsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Name',
        label: 'Name',
        sortable: true,
        'min-width': 150,
        name: 'nickName'
      },
      {
        datatype: 'string',
        description: 'Key',
        label: 'Generated Key',
        sortable: true,
        'min-width': 200,
        name: 'uniqueId'
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Last Sync',
        label: 'Last Sync',
        name: 'statusStr.timestamp',
        'min-width': 150,
        sortable: true
      },
      {
        datatype: 'string',
        description: 'State',
        label: 'State',
        sortable: true,
        'min-width': 150,
        name: 'status',
        display: 'iconAndText',
        displayKey: [
          {
            key: 'DISABLED',
            display: 'Paused',
            // color: '#77dab4',
            // textColor: '#008044',
            icon: 'far fa-pause-circle',
            iconDirection: 'right'
          },
          {
            key: 'INITIALIZING',
            display: 'Initializing',
            // color: '#77dab4',
            // textColor: '#008044',
            icon: ' ',
            iconDirection: 'right'
          },
          {
            key: 'HEALTHY',
            display: 'Connected',
            // color: '#77dab4',
            // textColor: '#008044',
            icon: 'far fa-check-circle',
            iconDirection: 'right'
          },
          {
            key: 'UNHEALTHY',
            display: 'Error Connecting',
            color: '',
            textColor: '#404c5a',
            icon: 'fal fa-exclamation-triangle',
            iconDirection: 'right'
          },
          {
            key: 'STALE',
            display: 'Stale',
            // color: '',
            // textColor: '#404c5a',
            icon: '',
            iconDirection: 'right'
          }
        ]
      }
    ]
  }
}

export { kubernetesAccountsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/integration_accounts/kubernetes-accounts.meta.js